import { ProductUtils } from '@wix/package-picker-shared';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { FeaturesGridGroup } from './FeaturesGridGroup';
import { FeaturesGridProductHeader } from './FeaturesGridProductHeader';

interface FeaturesGridProps {
  innerRef?: React.RefObject<HTMLDivElement>;
}

export const FeaturesGrid = ({ innerRef }: FeaturesGridProps) => {
  return (
    <PlatformFeaturesGrid.Root
      innerRef={innerRef}
      sortProducts={(products) => ProductUtils.sortProducts({ products })}
    >
      <PlatformFeaturesGrid.Header marginTop={28}>
        {({ products }) => {
          const sortedProducts = ProductUtils.sortProducts({ products });

          return sortedProducts?.map((product) => {
            if (!product.productId) {
              return null;
            }

            return (
              <FeaturesGridProductHeader
                key={product.productId}
                productId={product.productId!}
              />
            );
          });
        }}
      </PlatformFeaturesGrid.Header>
      <PlatformFeaturesGrid.Content>
        {({ products, namespaces }) => {
          return namespaces?.map((namespace) => (
            <FeaturesGridGroup
              key={namespace.id}
              group={namespace}
              products={products}
            />
          ));
        }}
      </PlatformFeaturesGrid.Content>
    </PlatformFeaturesGrid.Root>
  );
};
